/**
 * @(#)2019/6/17.
 * String，可以输入所有内容
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import React from "react";
import Editor from "./Editor";
import Basics from "../Basics";
import ReactDOM from "react-dom";
import { get, cloneDeep } from "../../../utils";
import uploadFileControl from "../../../utils/upload";
import { Connection, YxComponent } from "../../YxComponent";
import { isFunction } from "lodash";

//默认props
let defaul = () => {
  return {
    getFieldDecoratorParam: {},
    rules: {},
    disable: false, // 是否禁用富文本
    editorParam: {}, // 富文本参数
    /**
     * 富文本实例初始化
     *
     * @param {*} editItem 富文本实例
     */
    load: function (editItem) {},
  };
};

@Connection(defaul)
export default class extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      uploadFile: null,
      loading: false,
    };
  }

  async componentDidMount() {
    let uploadConfig = get(this.props, "uploadConfig", null);

    uploadConfig &&
      uploadConfig.assToken &&
      isFunction(uploadConfig.assToken) &&
      (uploadConfig.assToken = uploadConfig.assToken());

    if (uploadConfig != null) {
      this.setState({ loading: true });
      const uploadFile = await uploadFileControl(uploadConfig).finally(() =>
        this.setState({ loading: false })
      );
      this.setState({ uploadFile });
    }
  }

  get param() {
    const editorParam = get(this.props, "editorParam", {});
    return {
      editorParam,
      uploadFile: this.state.uploadFile,
      loading: this.state.loading,
      disable: this.props.disable,
    };
  }

  productionHtml() {
    let tmpProps = cloneDeep(this.props, 3);
    !tmpProps.rules.max ? (tmpProps.rules.max = 50000) : "";
    tmpProps.getFieldDecoratorParam.valuePropName = "html";
    tmpProps.getFieldDecoratorParam.validateTrigger = "inputChange";
    tmpProps.getFieldDecoratorParam.trigger = "inputChange";
    tmpProps.children = <Editor change={tmpProps.change} {...this.param} />;
    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    const disableClass =
      get(this.props, "disable", null) === true ? "editor_disable" : "";
    return (
      <div className={`yx_yxInput_editor ${disableClass}`}>
        {this.productionHtml()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/KindEditor/kindEditor.js